import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import {
  DialogTitle,
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Alert,
  Snackbar,
} from "@mui/material";
import { AllContext } from "../context";
import data from "../data-08-06.json";

export default function FormDialog({ open, setOpen }) {
  const [value, setValue] = React.useState(0);
  const { balance, setBalance, myShares, setMyShares } =
    React.useContext(AllContext);

  React.useEffect(() => {
    setValue(0);
  }, [open]);

  const ltp = open && data[open].lp;
  const amount = +ltp * value;
  const comission = amount * 0.004;
  const sebonFee = amount * 0.00015;
  const totalAmt = amount + comission + 25 + sebonFee;
  const costPerShare = +value ? totalAmt / value : 0;

  const handleChange = (event) => {
    setValue(event.target.value < 0 ? 0 : event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [errorToastOpen, setErrorToastOpen] = React.useState(false);

  const handleErrorToastClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setErrorToastOpen(false);
  };
  const [successToastOpen, setSuccessToastOpen] = React.useState(false);

  const handleSuccessToastClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessToastOpen(false);
  };

  // symbol, ltp, quantity, costPerShare, date
  const handleBuy = () => {
    if (amount > balance) {
      setErrorToastOpen(true);
    } else {
      setMyShares([
        ...myShares,
        {
          symbol: open,
          boughtltp: ltp,
          quantity: value,
          boughtCostPerShare: costPerShare,
          date: new Date().toLocaleDateString(),
        },
      ]);
      setBalance(balance - totalAmt);
      setSuccessToastOpen(true);
      setOpen(false);
    }
  };

  return (
    <div>
      <Snackbar
        open={errorToastOpen}
        autoHideDuration={6000}
        onClose={handleErrorToastClose}
      >
        <Alert variant="filled" severity="error">
          Your balance is not enough!
        </Alert>
      </Snackbar>

      <Snackbar
        open={successToastOpen}
        autoHideDuration={6000}
        onClose={handleSuccessToastClose}
      >
        <Alert variant="filled" severity="success">
          You successfully bought the share!
        </Alert>
      </Snackbar>

      <Dialog open={!!open} onClose={handleClose}>
        <DialogTitle>Buy Share</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To buy to this share, please enter amount here.
          </DialogContentText>

          <Table sx={{}} aria-label="simple table">
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">
                  Symbol
                </TableCell>
                <TableCell align="right">{open && data[open].s}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  LTP
                </TableCell>
                <TableCell align="right">
                  {open &&
                    "Rs. " +
                      ltp.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                      })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Quanity
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    p: 0,
                  }}
                >
                  <Box
                    component="form"
                    sx={{
                      "& .MuiTextField-root": { m: 1, width: "10ch" },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      type={"number"}
                      id="standard-basic"
                      value={value}
                      onChange={handleChange}
                      size="small"
                    />
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Amount
                </TableCell>
                <TableCell align="right">
                  {open &&
                    "Rs. " +
                      amount.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                      })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Comission
                </TableCell>
                <TableCell align="right">
                  {open &&
                    "Rs. " +
                      comission.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                      })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Sebon Fee
                </TableCell>
                <TableCell align="right">
                  {open &&
                    "Rs. " +
                      sebonFee.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                      })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  DP Charge
                </TableCell>
                <TableCell align="right">Rs. 25</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Total Amount
                </TableCell>
                <TableCell align="right">
                  {open &&
                    "Rs. " +
                      totalAmt.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                      })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Cost Per Share
                </TableCell>
                <TableCell align="right">
                  {open &&
                    "Rs. " +
                      costPerShare.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                      })}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={!+value} onClick={handleBuy}>
            Buy
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
